//---------------------
//로그인
//---------------------
const loanRouter = [
  //메인
  {
    path: "/loan",
    name: "loan",
    component: () => import("../views/loan/LoanMainView.vue"),
  },

  // 로그인
  {
    path: "/loan/login",
    name: "loan-login",
    component: () => import("../views/loan/LoanLoginView.vue"),
  },

  // 실시간 대출 상담 채팅 (loan-relay 연동, NZSC-3178)
  {
    path: "/loan/relay-chat",
    name: "loan-relay-chat",
    component: () => import("../views/loan/LoanRelayChatView.vue"),
  },

  // 정보
  {
    path: "/loan/age",
    name: "loan-age",
    component: () => import("../views/loan/info/LoanAgeView.vue"),
  },
  {
    path: "/loan/house",
    name: "loan-house",
    component: () => import("../views/loan/info/LoanHouseView.vue"),
  },
  {
    path: "/loan/income",
    name: "loan-income",
    component: () => import("../views/loan/info/LoanIncomeView.vue"),
  },
  {
    path: "/loan/hold",
    name: "loan-hold",
    component: () => import("../views/loan/info/LoanHoldView.vue"),
  },
  {
    path: "/loan/hold-active",
    name: "loan-hold-active",
    component: () => import("../views/loan/info/LoanHoldActiveView.vue"),
  },
  {
    path: "/loan/hold-repay",
    name: "loan-hold-repay",
    component: () => import("../views/loan/info/LoanHoldRepayView.vue"),
  },
  {
    path: "/loan/property",
    name: "loan-property",
    component: () => import("../views/loan/info/LoanPropertyView.vue"),
  },
  {
    path: "/loan/condition",
    name: "loan-condition",
    component: () => import("../views/loan/info/LoanConditionView.vue"),
  },
  {
    path: "/loan/difficult",
    name: "loan-difficult",
    component: () => import("../views/loan/info/LoanDifficultView.vue"),
  },

  // 데이터
  {
    path: "/loan/gov-analyze",
    name: "loan-gov-analyze",
    component: () => import("../views/loan/data/gov/LoanGovAnalyzeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // 전세대출 불가용 별도 URL 가지는 페이지
  {
    path: "/loan/gov-analyze-impossible",
    name: "loan-gov-analyze-impossible",
    component: () => import("../views/loan/data/gov/LoanImpossibleGovAnalyzeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // 가능
  {
    path: "/loan/gov/possible",
    name: "loan-gov-possible",
    component: () => import("../views/loan/data/gov/LoanPossibleGovView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/loan/gov/possible/analyze",
    name: "loan-gov-possible-analyze",
    component: () => import("../views/a-b/LoanPossibleGovAnalyzeView-A.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // 불가능
  {
    path: "/loan/gov/impossible",
    name: "loan-gov-impossible",
    component: () => import("../views/loan/data/gov/LoanImPossibleGovView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/loan/gov/impossible/analyze",
    name: "loan-gov-impossible-analyze",
    component: () => import("../views/loan/data/gov/LoanImpossibleGovAnalyzeReasonView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // 대출 가이드 - LTV, DSR, DTI 개념설명
  {
    path: "/loan/guide/concept",
    name: "loan-guide-concept",
    component: () => import("../components/report/buy/loan/guide/LoanConceptGuide.vue"),
  },

  // 대출 가이드 - 대출 상환 방식별 장단점
  {
    path: "/loan/guide/repayment",
    name: "loan-guide-repayment",
    component: () => import("../components/report/buy/loan/guide/LoanRepaymentGuide.vue"),
  },

  // 대출 가이드 - 금리 구성요소와 적용방식
  {
    path: "/loan/guide/interest",
    name: "loan-guide-interest",
    component: () => import("../components/report/buy/loan/guide/LoanInterestGuide.vue"),
  },

  // 대출 상담 채팅
  {
    path: "/loan/consult/chat",
    name: "loan-consult-chat",
    component: () => import("../components/report/buy/loan/guide/LoanConsultChat.vue"),
  },

  // 대출 가이드 - 주택담보대출 금리 낮추는 팁
  {
    path: "/loan/guide/interest-tip",
    name: "loan-guide-interest-tip",
    component: () => import("../components/report/buy/loan/guide/LoanInterestTipGuide.vue"),
  },

  // 대출 가이드 - 주택담보대출 한도 올리는 팁
  {
    path: "/loan/guide/limit-tip",
    name: "loan-guide-limit-tip",
    component: () => import("../components/report/buy/loan/guide/LoanLimitTipGuide.vue"),
  },
];

export default loanRouter;
